import { applicationsId } from "./enumsByGames";


export const appDefaultValuesEnum = (gameId) => {
  return {
    LANGUAGE: 'en',
    APPLICATION_ID:
      process.env.REACT_APP_ENV === 'production'
        ? applicationsId[gameId]['production']
        : applicationsId[gameId]['development'],
    changeConnectionUrl: process.env.REACT_APP_ENV === 'production',
  };
}
